import { FC } from "react";
import GroupsTable from "./GroupsTable";

const GroupsView: FC = () => {
  return (
    <div className="flex flex-col h-full gap-4 min-h-0">
      <GroupsTable />
    </div>
  );
};

export default GroupsView;